export default __webpack_public_path__ + "static/img02-8ad6f6ad1963efca40cfc415abf7cf9e.png";